import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgSwapVerticalLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M11 6a1 1 0 0 0-1.707-.707l-4 4A1 1 0 0 0 6 11h3v7a1 1 0 1 0 2 0zM14 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1.707.707l4-4A1 1 0 0 0 18 13h-3V6a1 1 0 0 0-1-1'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgSwapVerticalLine)
export default ForwardRef
